import { render, staticRenderFns } from "./companySummary.vue?vue&type=template&id=4d452d92"
import script from "./companySummary.vue?vue&type=script&lang=js"
export * from "./companySummary.vue?vue&type=script&lang=js"
import style0 from "./companySummary.vue?vue&type=style&index=0&id=4d452d92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports